export enum OperationCancelStatus {
  CANCEL_FAILED = 'cancel failed',
  CANCEL_IN_PROGRESS = 'cancel in progress',
  CANCEL_COMPLETE = 'cancel complete'
}
